import PropTypes from 'prop-types';

export const headerDataShape = {
  headerTitle: PropTypes.string,
  module: PropTypes.string
};

export const menuDataShape = {
  logoClass: PropTypes.string,
  logoUrl: PropTypes.string,
  module: PropTypes.string
};


export default {
  headerData: PropTypes.shape(headerDataShape),
  menuData: PropTypes.shape(menuDataShape),
  module: PropTypes.string,
  initModuleAction: PropTypes.func
}
